// extracted by mini-css-extract-plugin
export default {"textarea":"styles__textarea___oOc2a","buttonLeft":"styles__buttonLeft___Q74e1"};